
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.249 3.889L7.192 4.935l-.082-.277 3.801-1.932-.46-1.56-.536.273-.112-.379-.625.318.111.38-2.639 1.34-.154-.522-2.541 1.292-.313.159-.615.312.19.643.531-.27a.887.887 0 01-.452.606c-1.327.675-2.08 2.334-1.678 3.697l.707 2.399 2.72-1.383-.298-1.013.64-.325c.765-.39 1.24-1.276 1.167-2.093l.982-.5-.155-.523 2.057-1.046-.19-.642zm-4.985.865l1.827-.93.189.643-1.827.93-.19-.643zm.315 1.069l1.827-.93.189.643-1.827.929-.19-.642zm.618 2.228l-.64.325-.195-.662.36-.183.112.378.625-.318-.111-.378.559-.284c-.017.45-.292.909-.71 1.122z"}})])
          )
        }
      }
    